import { linkToAssignmentPage } from "../../links";

export function linkToDeleteAssignment(
  classId?: string,
  assignmentId: string = ":assignmentId"
) {
  return `${linkToAssignmentPage(classId, assignmentId)}/delete`;
}
